// extracted by mini-css-extract-plugin
export default {"container":"DashboardCard_container__SrbaD","header":"DashboardCard_header__3aH-5"};